var map = {
	"./aguacate_sabor.png": 2970,
	"./arrow-up.png": 8141,
	"./chocolate_sabor.png": 1875,
	"./footebg.png": 3057,
	"./fuetito_ejemplo.png": 289,
	"./galletas_sabor.png": 8990,
	"./gazpacho_sabor.png": 314,
	"./humus_sabor.png": 7008,
	"./logo-snackin.png": 8647,
	"./mostaza_sabor.png": 2871,
	"./naranja_sabor.png": 4984,
	"./packet1.png": 6520,
	"./packet2.png": 8807,
	"./packet3.png": 4284,
	"./packet4.png": 5976,
	"./packet5.png": 3146,
	"./packet6.png": 8637,
	"./packet7.png": 1363,
	"./packet8.png": 9373,
	"./packet9.png": 9996,
	"./patatas_sabor.png": 2564,
	"./salsabbq_sabor.png": 4482,
	"./set_trade.png": 7370,
	"./wasabi_sabor.png": 9481
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;